import React from "react";
import hoistNonReactStatics from 'hoist-non-react-statics';

const LoadingContext = React.createContext();

function LoadingProps(props) {
  const [loading, setLoading] = React.useState(false);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {props.children}
    </LoadingContext.Provider>
  );
}

export const withLoading = WrapperComponent => {
    const C = props => (
      <LoadingContext.Consumer>
        {loadingProps => <WrapperComponent {...props} {...loadingProps} />}
      </LoadingContext.Consumer>
    );
    return hoistNonReactStatics(C, WrapperComponent);
  };
  
  export const useLoading = () => {
    const loadingProps = React.useContext(LoadingContext);
    return loadingProps;
  };

export default LoadingProps;
